import Reveal from '@/components/base/Reveal';
import { trustPoints } from '@/mocks/home';

export default function TrustSection() {
  return (
    <section id="trust" className="bg-primary-50 border-y border-primary-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-bold tracking-wide">
              <i className="ri-shield-star-line"></i>
              内容说明
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
              为什么可以放心逛黑料福利
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
              我们只做话题的整理与呈现，把判断留给你自己。热闹归热闹，社区该有的底线一条都不少。
            </p>
          </div>
        </Reveal>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustPoints.map((point, index) => (
            <Reveal key={point.title} delay={index * 80}>
              <div className="h-full bg-background-50 border border-background-200 rounded-lg p-5 transition-colors hover:border-primary-300">
                <span className="w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${point.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading font-bold text-base md:text-lg text-foreground-950">
                  {point.title}
                </h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{point.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col md:flex-row md:items-center gap-4 bg-background-50 border border-primary-200 rounded-lg p-5 md:p-6">
            <span className="w-12 h-12 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center shrink-0">
              <i className="ri-error-warning-line text-2xl"></i>
            </span>
            <p className="text-sm text-foreground-700 leading-relaxed flex-1">
              <span className="font-bold text-foreground-950">社区守则：</span>
              不发布未经核实的个人信息，不进行人身攻击，不引导网暴。看到违规内容可以点举报，我们会在核实后处理。
            </p>
            <a
              href="#faq"
              className="cursor-pointer whitespace-nowrap shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              查看社区守则
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}